export default {
  create: {
    title: 'Adicionar',
    subtitle: 'Usuário',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Usuário',
    button: {
      add: 'Novo usuário',
    },
  },
  list: {
    title: 'Usuários',
    subtitle: 'Lista',
    add: 'Novo usuário',
  },
  table: {
    title: 'Usuários Ativos',
    searchPlaceholder: 'Buscar por algo...',
    noContent: 'Ainda não tem nenhum usuário cadastrado.',
    columns: {
      name: 'Nome',
      email: 'E-mail',
      role: 'Função',
      options: 'Opções',
    },
    actions: {
      delete: 'Deletar',
    },
  },
  delete: {
    title: 'Confirme exclusão de usuário',
    message: 'Tem certeza que deseja excluir esse usuário?',
  },
  account: {
    title: 'Perfil',

    form: {
      name: {
        label: 'Nome',
        placeholder: 'Nome',
      },

      email: {
        label: 'E-mail',
        placeholder: 'E-mail',
        invalid: 'E-mail é obrigatório',
      },

      userType: {
        label: 'Tipo de usuário',
      },

      role: {
        label: 'Função',
      },

      oldPassword: {
        label: 'Senha antiga',
      },

      password: {
        label: 'Senha',
        invalid: 'As senhas não são iguais',
      },

      passwordConfirmation: {
        label: 'Confirmar senha',
        invalid: 'As senhas não são iguais',
      },

      sendPassword: {
        label: 'Definir senha por e-mail',
        options: {
          yes: 'Sim',
        },
      },

      submit: 'Salvar',
    },

    roles: {
      administrator: 'Administrador',
      none: 'Nenhum',
    },
  },
  profile: {
    title: 'Perfil do usuário',
    subtitle: 'Visão geral',
  },
  alert: {
    deleted: 'Usuário deletado com sucesso',
  },
};
